export default __webpack_public_path__ + "static/media/img-10.47c0b8af.jpg";